
export const headerConfig = {
  not_logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/sakura/vip/header/header_bg2.png',
    style: ""
  },
  logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/sakura/vip/header/header_bg2.png',
    main_title_color: "#fff",
    sub_title_color: "#fff",
    tips_color: "#fff",
    game_name: "魔卡少女樱：回忆钥匙"
  },
  operation_btn: {
    office_website: {
      width: "",
      height: "",
      background_image: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/vip/header/btn_05.png',
      style: "",
      link: "https://sakura.qingcijoy.com/official/index.html"
    },
    login: {
      width: "",
      height: "",
      background_image: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/vip/header/btn_06.png',
      style: "top:45%;transform:translateY(-45%)"
    },
    change_account: {
      width: "",
      height: "",
      background_image: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/vip/header/btn_07.png',
      style: "top:45%;transform:translateY(-45%)"
    },
    join_active: {
      width: "",
      height: "",
      background_image: "",
      img: "",
      style: ""
    },
    logout: {
      width: "",
      height: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/vip/header/btn_10.png',
      style: "top:45%;transform:translateY(-45%)"
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sakura/vip/headerConfig.js